/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_qr_ecc_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quartile`)
};

const es_qr_ecc_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cuartil`)
};

const de_qr_ecc_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quartil`)
};

const nl_qr_ecc_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kwartiel`)
};

const fr_qr_ecc_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quartile`)
};

const it_qr_ecc_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quartile`)
};

const pt_br2_qr_ecc_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quartil`)
};

const pt_qr_ecc_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quartil`)
};

const ja_qr_ecc_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`準高`)
};

const zh_qr_ecc_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`较高`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const qr_ecc_q = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.qr_ecc_q(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("qr_ecc_q", locale)
	if (locale === "en") return en_qr_ecc_q(inputs)
	if (locale === "es") return es_qr_ecc_q(inputs)
	if (locale === "de") return de_qr_ecc_q(inputs)
	if (locale === "nl") return nl_qr_ecc_q(inputs)
	if (locale === "fr") return fr_qr_ecc_q(inputs)
	if (locale === "it") return it_qr_ecc_q(inputs)
	if (locale === "pt-BR") return pt_br2_qr_ecc_q(inputs)
	if (locale === "pt") return pt_qr_ecc_q(inputs)
	if (locale === "ja") return ja_qr_ecc_q(inputs)
	return zh_qr_ecc_q(inputs)
};